import React, { useState } from 'react';
import { PageContentLayout, PageHeaderLayout } from '../../../shared/layout';
import { Button } from 'antd';
import { EnvironmentOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import RetailStoresLocationTab from './RetailStoresLocationTab';
import HelpCenterModal from '../../../shared/components/HelpCenterModal/HelpCenterModal';
import { buildUserActions } from '../../../../core/utils/helpCenter/buildUserActions';
import '../styles/index.scss';

const RetailStoresMainView = ({
  currentuser,
  locationList,
  parentState,
  changeLocationMap,
  onChange,
  onCsvUploadComplete,
  createLocation,
  deleteLocation,
  editRetailLocation,
  resetParentState,
  updateOrgLocation,
  cartProvider,
  onChangeStateValue,
  selectedLocations,
  onSubmitAudience,
  attributionAudienceName,
  selectedOrg,
  attributionAudiences,
  google,
  deleteAudience,
  isSelfService,
  complianceAudiences,
}) => {
  document.title = 'Retail Stores Main View';

  const [helpVisible, setHelpVisible] = useState(false);
  const userActions = buildUserActions(currentuser?.permission, currentuser?.features);

  return (
    <React.Fragment>
      <div className="retail-stores-page-header">
        <PageHeaderLayout
          titleIcon={<EnvironmentOutlined />}
          title={'Retail Stores'}
          rightContent={
            <Button
              type="default"
              icon={<QuestionCircleOutlined />}
              onClick={() => setHelpVisible(true)}
            >
              Help Center
            </Button>
          }
        />
      </div>
      <PageContentLayout>
        <div className="retail-stores-root">
          <RetailStoresLocationTab
            locationList={locationList}
            parentState={parentState}
            changeLocationMap={changeLocationMap}
            onChange={onChange}
            onCsvUploadComplete={onCsvUploadComplete}
            createLocation={createLocation}
            deleteLocation={deleteLocation}
            editRetailLocation={editRetailLocation}
            resetParentState={resetParentState}
            updateOrgLocation={updateOrgLocation}
            cartProvider={cartProvider}
            onChangeStateValue={onChangeStateValue}
            selectedLocations={selectedLocations}
            onSubmitAudience={onSubmitAudience}
            attributionAudienceName={attributionAudienceName}
            selectedOrgId={selectedOrg && selectedOrg.id}
            attributionAudiences={attributionAudiences}
            currentuser={currentuser}
            google={google}
            deleteAudience={deleteAudience}
            isSelfService={isSelfService}
            complianceAudiences={complianceAudiences}
          />
        </div>
      </PageContentLayout>
      <HelpCenterModal
        visible={helpVisible}
        onClose={() => setHelpVisible(false)}
        feature="RETAIL_STORES"
        title="Retail Stores Help Center"
        userActions={userActions}
      />
    </React.Fragment>
  );
};

export default RetailStoresMainView;
